

import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs/Subject';
  
import { GlobalComponent } from 'src/app/global/global.component';
import { ErrorService } from 'src/app/error.service';
import { exceededhourBO } from './operational-dashboard.modal';

@Injectable()

export class GetHTTPService extends Subject<DataStateChangeEventArgs>{
  constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent) {
    super();
  }
  public execute(state: exceededhourBO): void {
    this.getCareList(state).subscribe(x => super.next(x));
  }
 
  getCareList(state?: exceededhourBO): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/Employee/GetEmpUMPI", state)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['result'],
            count: response['count']
          }
      ))
  }

  
}

